import React from 'react';
import ReactLoading from 'react-loading';
function Loader() {
  return <div style={{display:"flex",height:"100%",width:"100%",alignItems:"center",justifyContent:"center"}}>
      <ReactLoading type="spin" color="cyan" width={100} height={100}/>
  </div>;
}

export default Loader;
